import React from "react";
import Typography from "aldoo-ra/Typography";

export default function NumberCardWidget({ data, label, color = "#6366f1", latestTags, fullscreen }) {
    const latestValue =
        data && data.length > 0 ? data[data.length - 1].value : null;

    const prevValue =
        data && data.length > 1 ? data[data.length - 2].value : null;

    const delta =
        latestValue !== null && prevValue !== null
            ? latestValue - prevValue
            : null;

    const deltaPct =
        delta !== null && prevValue !== 0
            ? ((delta / Math.abs(prevValue)) * 100).toFixed(1)
            : null;

    const unit = latestTags?._unit || "";
    const hasCapacity = latestTags && latestTags.capacity !== undefined;
    const usedValue = latestTags?.used !== undefined ? latestTags.used : latestValue;
    const capacityLabel = hasCapacity
        ? `${usedValue !== null ? Number(usedValue).toLocaleString() : "--"}GB / ${Number(latestTags.capacity).toLocaleString()}GB`
        : null;

    const numberStyle = fullscreen
        ? { fontSize: "6rem", fontWeight: 800, lineHeight: 1, color }
        : { fontSize: "2.5rem", fontWeight: 700, lineHeight: 1, color };
    const labelStyle = fullscreen
        ? { fontSize: "1.4rem", marginTop: "0.5rem" }
        : { fontSize: "0.85rem", marginTop: "0.25rem" };
    const deltaStyle = fullscreen
        ? { fontSize: "1.2rem", marginTop: "0.5rem" }
        : { fontSize: "0.8rem", marginTop: "0.25rem" };

    return (
        <div style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            padding: fullscreen ? "2rem" : "1rem",
            height: "100%",
        }}>
            <Typography variant="admin_h1" style={numberStyle}>
                {latestValue !== null ? `${Number(latestValue).toFixed(2)}${unit}` : "--"}
            </Typography>
            {delta !== null && (
                <Typography variant="admin_label" style={{ ...deltaStyle, color: delta >= 0 ? "#22c55e" : "#ef4444" }}>
                    {delta >= 0 ? "↑" : "↓"} {Math.abs(delta).toLocaleString()}
                    {deltaPct && ` (${deltaPct}%)`}
                </Typography>
            )}
        </div>
    );
}
